import { render, staticRenderFns } from "./PeriodLocks.vue?vue&type=template&id=1711370b&scoped=true"
import script from "./PeriodLocks.vue?vue&type=script&lang=js"
export * from "./PeriodLocks.vue?vue&type=script&lang=js"
import style0 from "./PeriodLocks.vue?vue&type=style&index=0&id=1711370b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711370b",
  null
  
)

export default component.exports